import strings from '../../lang/strings.json';

export default {
  init() {
    const gravityFormWrappers = document.querySelectorAll('.gform_wrapper');

    this.currentLang = document.querySelector('html').lang;
    gravityFormWrappers.forEach(gravityFormWrapper => {
      const form = gravityFormWrapper.querySelector('form');

      if (!form) return;
      this.initializeFormFields(form)

      const observer = new MutationObserver(records => {
        records.forEach(record => {
          if (record.type === 'childList') {
            let scrolled = false;
            Array.from(record.addedNodes).filter(n => n.tagName === 'FORM').forEach(form => {
              this.initializeFormFields(form);

              const formFields = gravityFormWrapper.querySelectorAll('li.gfield');
              formFields.forEach(formField => {
                const display = formField.style.display;
                if (display !== 'none' && !formField.classList.contains('gfield_error') && formField.classList.contains('gfield_contains_required')) {
                  formField.classList.add('gfield_check');
                }

                // hide all validation live messages
                const validationMessages = formField.querySelectorAll('.validation_message');
                if (validationMessages.length) {
                  validationMessages.forEach(validationMessage => {
                    validationMessage.removeAttribute('aria-live');
                    validationMessage.setAttribute('aria-hidden', 'true');
                  });
                }

                // add aria validation if input file type has an error
                const fileInput = formField.querySelector('input[type="file"]');
                if (formField.classList.contains('gfield_error') && fileInput) {
                  const fileLabel = fileInput.parentElement.querySelector('label');
                  fileLabel.setAttribute('aria-invalid', 'true');
                }

                if (formField.classList.contains('gfield_error')) {
                  if (!scrolled) {
                    scrolled = true;
                    setTimeout(() => {
                      const [firstFocusable] = this.getKeyboardFocusableElements(formField);
                      if (firstFocusable) {
                        firstFocusable.focus();
                        formField.scrollIntoView();
                      }
                    }, 200);
                  }
                }
              });
            })

            if (Array.from(record.removedNodes).find(element => element.nodeType === 1 && element.classList.contains('ms-contact-form--consumer'))) {
              const formFooter = form.querySelector('.gform_footer');
              formFooter.dataset.sending = false;
              formFooter.classList.remove('sending');
            }

            if (Array.from(record.addedNodes).find(element => element.nodeType === 1 && element.classList.contains('gform_ajax_spinner'))) {
              const formFooter = record.target;
              formFooter.dataset.sending = true;
              formFooter.classList.add('sending');
            }
          }
        })
      });

      observer.observe(gravityFormWrapper, { subtree: true, childList: true, attributes: true });
    });
  },

  initializeFormFields(form) {
    this.initializeSelect(form);
    this.initializeFileUpload(form);
    this.initializeTextArea(form);
    this.initializeTextField(form);
    this.initializeTextEmail(form);
    this.initializeLabelTransition(form);
    this.initializeConsentFields(form);
    this.initializeA11y(form);
  },

  initializeConsentFields(form) {
    const consentFields = form.querySelectorAll('.ginput_container_consent');
    consentFields.forEach(consentField => {
      consentField.parentElement.classList.add('gfield_consent_wrapper');
    })
  },

  initializeTextArea(form) {
    const textAreaContainers = form.querySelectorAll(['.ginput_container_textarea']);
    textAreaContainers.forEach(textAreaContainer => {
      const textArea = textAreaContainer.querySelector(['textarea']);
      textArea.onkeyup = () => {
        textArea.style.height = '1px';
        textArea.style.height = (textArea.scrollHeight)+'px';
      }
      const textAreaHeight = textArea.getBoundingClientRect().height;

      if (textArea.scrollHeight > textAreaHeight) {
        textArea.style.height = '1px';
        textArea.style.height = (textArea.scrollHeight)+'px';
      }
    });
  },

  initializeTextEmail(form) {
    const textEmailContainers = form.querySelectorAll(['.ginput_container_email']);
    textEmailContainers.forEach(textEmailContainer => {
      const textEmail = textEmailContainer.querySelector('input');
      textEmail.setAttribute('type', 'text');
      textEmail.setAttribute('validate', 'email|text');
    })
  },

  initializeTextField(form) {
    const textFieldContainers = form.querySelectorAll(['.ginput_container_text']);
    textFieldContainers.forEach(textFieldContainer => {
      const textField = textFieldContainer.querySelector('input');
      textField.setAttribute('type', 'text');
      textField.setAttribute('validate', 'text');
    })
  },

  initializeSelect(form) {
    // select init
    const selectContainers = form.querySelectorAll('.ginput_container_select');

    selectContainers.forEach(selectContainer => {
      const selectWrapper = selectContainer.parentElement;
      selectWrapper.classList.add('gfield_select_wrapper');

      // TO DO: Future reference for custom select
      // this.createSelectOption(selectContainer);
    });

    // TO DO: Future reference for custom select
    // this.initializeSelectA11y(form);
  },

  initializeFileUpload(form) {
    const fileUploadContainers = form.querySelectorAll('.ginput_container_fileupload');

    fileUploadContainers.forEach(fileUploadContainer => {
      const fileUploadWrapper = fileUploadContainer.parentElement;
      // add class for the file upload wrapper
      fileUploadWrapper.classList.add('gfield_fileupload_wrapper');

      const fieldLabel = fileUploadWrapper.querySelector('.gfield_label');
      const fieldDescription = fileUploadWrapper.querySelector('.gfield_description');
      const labelFor = fieldLabel.getAttribute('for');
      fieldLabel.setAttribute('for', '');

      const fileInput = fileUploadContainer.querySelector('input[type="file"]');
      const fileUploadLabel = document.createElement('label');
      const fileUploadSpan = document.createElement('span');
      fileUploadLabel.classList.add('ginput_container_fileupload__label');
      fileUploadLabel.setAttribute('for', labelFor);
      fileUploadLabel.setAttribute('aria-controls', 'filename')
      fileUploadLabel.removeAttribute('aria-controls');

      fileUploadSpan.setAttribute('role', 'button');
      fileUploadSpan.innerText = 'Choose file';

      fileUploadLabel.appendChild(fileUploadSpan);
      setTimeout(() => {
        fileUploadLabel.tabIndex = 0;
      });

      const filesContainer = document.createElement('ul');
      filesContainer.setAttribute('aria-label', strings[this.currentLang].selectedFileList);
      filesContainer.classList.add('ginput_container_fileupload__files_container')
      filesContainer.dataset.show = false;

      fileInput.addEventListener('change', () => {
        this.renderFiles(fileInput, filesContainer);
        fileUploadWrapper.classList.remove('gfield_error')
      });

      const handleFileUploadLabelKeypress = e => {
        if(e.which === 32 || e.which === 13){
          e.preventDefault();
          fileInput.click();
        }
      }

      fileUploadLabel.addEventListener('keypress', handleFileUploadLabelKeypress);
      fileUploadLabel.addEventListener('keyup', handleFileUploadLabelKeypress);

      fileUploadWrapper.insertBefore(fieldDescription, fileUploadContainer);
      fileUploadContainer.insertBefore(fileUploadLabel, fileInput);
      fileUploadContainer.appendChild(filesContainer);
    });
  },

  initializeLabelTransition(form) {
    const textFieldContainers = form.querySelectorAll(['.ginput_container_text', '.ginput_container_phone', '.ginput_container_email', '.ginput_container_textarea']);
    textFieldContainers.forEach((textFieldContainer) => {
      const inputContainer = textFieldContainer.parentElement;
      const textField = textFieldContainer.querySelector(['input', 'textarea']);
      const label = inputContainer.querySelector('.gfield_label');
      let shouldFocusOut = true;

      setTimeout(() => {
        if (label.querySelector('mmi')) {
          label.style.userSelect = 'none';
        }
      });
      label.addEventListener('click', () => {
        shouldFocusOut = false;
      })
      label.classList.add('gfield_label__transitioned');

      if (textField.value) {
        label.classList.add('gfield_label__transitioned--active');
      }
      textField.addEventListener('focus', () => {
        label.classList.add('gfield_label__transitioned--active');
      })
      textField.addEventListener('focusout', (e) => {
        setTimeout(() => {
          if (!e.target.value && shouldFocusOut) {
            label.classList.remove('gfield_label__transitioned--active');
          }
          shouldFocusOut = true;
        }, 100)
      })

    })
  },

  initializeSelectA11y(form) {
    let timeoutId = 0;
    form.addEventListener('focusout', e => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        const { target } = e;
        if (target.tagName === 'SELECT') {
          const selectContainer = target.parentElement;
          selectContainer.classList.remove('ginput_container_select--active');
        }
      }, 100);
    });
  },

  initializeA11y(form) {
    const tabElements = form.querySelectorAll('[tabindex]');
    tabElements.forEach(tabElement => {
      tabElement.removeAttribute('tabindex');
    });

    // Set the label text as aria-label for proper announcement in screen-readers.
    const labelElements = form.querySelectorAll('.gfield_consent_label');

    labelElements.forEach(labelElement => {
      labelElement.setAttribute('aria-label', labelElement.textContent);
    });
  },

  createSelectOption(selectContainer) {
    const optionContainer = document.createElement('div');
      optionContainer.classList.add('ginput_container_select__option_container');

      const select = selectContainer.querySelector('select');

      const options = selectContainer.querySelectorAll('option');
      options.forEach(option => {
        const button = document.createElement('button');
        button.classList.add('ginput_container_select__option');
        button.dataset.value = option.value;
        button.innerHTML = option.innerHTML;
        button.type = 'button';
        button.onclick = () => {
          select.value = option.value;
        };
        optionContainer.appendChild(button);
      });

      select.onclick = () => {
        if (selectContainer.classList.contains('ginput_container_select--active')) {
          selectContainer.classList.remove('ginput_container_select--active');
        } else {
          selectContainer.classList.add('ginput_container_select--active');
        }
      }
      selectContainer.appendChild(optionContainer);
  },

  renderFiles(fileInput, filesContainer) {
    filesContainer.innerHTML = '';

    Array.from(fileInput.files).forEach(file => {
      const li = document.createElement('li');

      const fileContainer = document.createElement('div');
      const fileText = document.createElement('p');
      const closeButton = document.createElement('button');
      closeButton.setAttribute('aria-label', `${strings[this.currentLang].remove} ${file.name}`);

      fileContainer.classList.add('ginput_container_fileupload__files_container__item')
      fileText.innerText = file.name;
      closeButton.setAttribute('type', 'button')
      closeButton.onclick = () => {
        fileInput.value = '';
        this.renderFiles(fileInput, filesContainer)
      }

      fileContainer.appendChild(fileText);
      fileContainer.appendChild(closeButton);
      li.appendChild(fileContainer)

      filesContainer.appendChild(li);
    });

    filesContainer.dataset.show = !!filesContainer.childElementCount;

    let deviceFileTarget = filesContainer;
    let timing = 300; // desktop

    // setup elements for focusing
    if (/iPhone|iPod|iPad/.test(navigator.platform)) {
      deviceFileTarget = filesContainer.querySelector('li > div > p'); // first <li><div> only
      timing = 1300; // mobile
    }

    // set a11y requirements
    deviceFileTarget.setAttribute('aria-label', '');
    deviceFileTarget.setAttribute('tabindex', '-1');

    // focus on the new element after appending it
    setTimeout(() => {
      deviceFileTarget.focus();
    }, timing);
  },

  getKeyboardFocusableElements (element = document) {
    return Array.from(element.querySelectorAll('a, button, input:not([type="hidden"]), textarea, select, details, [tabindex]:not([tabindex="-1"]), [role="button"]'));
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/contact-form.js